<template>
  <div>
    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.planning.producer.title") }}
        </div>
      </CCol>
      <CCol sm="6" class="justify-content-end d-flex">
        <div>
          <CButton color="primary" class="mb-3" @click="addProducer()">
            <font-awesome-icon icon="plus" class="mr-2" />
            {{ $t("role.planning.producer.addProducer") }}
          </CButton>
        </div>
      </CCol>
    </CRow>

    <CRow v-if="producerData && producerData.length > 0" class="p-3">
      <Header
        :data="[
          $t('models.productproducer.producer'),
          $t('models.mpc.market_wh'),
          $t('models.mpc.order_offset'),
          $t('models.mpc.delivery_offset'),
          $t('models.mpc.delivery_type'),
          $t('models.mpc.delivery_method'),
          $t('models.family_address.country'),
          $t('models.family_address.phone'),
          $t('models.logistics.connections.contacts'),
          $t('models.logistics.connections.serviceZone'),
          'Actions',
        ]"
      />
      <Row
        v-for="(item, index) in producerData"
        :key="index"
        :data="[
          {
            data: producerName(item.producer.role.name, item.producer.role.id),
            type: 'html',
          },
          { data: warehouse(item.market_wh), type: 'text' },
          { data: item.order_offset, type: 'text' },
          { data: item.delivery_offset, type: 'text' },
          { data: deliveryType(item.delivery_type), type: 'text' },
          { data: deliveryMode(item.delivery_method), type: 'text' },
          { data: item.producer.role.country, type: 'text' },
          { data: item.producer.role.tel, type: 'text' },
          { data: item.producer.role.info_contact, type: 'text' },
          { data: item.producer.role.desc_zone, type: 'text' },
          { data: '', type: 'actions' },
        ]"
        :border="true"
        :topAligned="true"
      >
        <template #actions>
          <div class="d-flex justify-content-end">
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="editProducer(item)"
            >
              <font-awesome-icon icon="edit" />
            </CButton>
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="showDeleteConfirmation(item.id)"
            >
              <font-awesome-icon icon="trash-alt" />
            </CButton>
          </div>
        </template>
      </Row>
    </CRow>

    <ProducerModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      :wh="whData"
      :DeliveryMode="DeliveryMode"
      :DeliveryType="DeliveryType"
      @submitted="fetchData"
    />

    <CModal
      :title="$t('role.planning.closing_days.modal.title')"
      :show.sync="deleteModal.show"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <p>
        {{ $t("role.planning.closing_days.modal.subtitle") }}
      </p>
      <p>
        {{ $t("role.planning.closing_days.modal.text") }}
      </p>
      <template #footer>
        <CButton color="primary" @click="onModalConfirm">{{
          $t("common.editor.button.confirm")
        }}</CButton>
        <CButton color="primary" variant="outline" @click="onModalClose">{{
          $t("common.editor.button.cancel")
        }}</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import { apiGet, apiDelete } from "../../../helpers/apiHelper";
import ProducerModal from "./ProducerModal.vue";
import Header from "../../../common/table/Header.vue";
import Row from "../../../common/table/Row.vue";

export default {
  components: {
    ProducerModal,
    Header,
    Row,
  },
  data() {
    return {
      producerData: [],
      modal: {
        show: false,
        title: this.$t("models.market_plan.addForm.modalTitle"),
        values: {},
        editMode: false,
        editId: null,
      },
      whData: [],
      DeliveryType: [
        { id: 1, name: this.$t("role.planning.deliveryType.delivery") },
        { id: 2, name: this.$t("role.planning.deliveryType.pickUp") },
        { id: 3, name: this.$t("role.planning.deliveryType.directDelivery") },
      ],
      DeliveryMode: [
        { id: 1, name: this.$t("role.planning.deliverMethod.perOrder") },
        { id: 2, name: this.$t("role.planning.deliverMethod.perProduct") },
        { id: 3, name: this.$t("role.planning.deliverMethod.perProductOrder") },
      ],
      deleteModal: {
        show: false,
        producerIdToDelete: null,
      },
    };
  },

  methods: {
    deliveryType(typeId) {
      const type = this.DeliveryType.find((t) => t.id === typeId);
      return type ? type.name : "";
    },

    deliveryMode(modeId) {
      const mode = this.DeliveryMode.find((m) => m.id === modeId);
      return mode ? mode.name : "";
    },

    producerName(name, id) {
      return name ? `<strong>${name}</strong><br>P-${id}` : "";
    },

    warehouse(whId) {
      const wh = this.whData.find((w) => w.id === whId);
      return wh ? wh.address.to : "";
    },

    addProducer() {
      this.modal.title = this.$t("role.planning.producer.addProducer");
      this.modal.values = {};
      this.modal.editMode = false;
      this.modal.editId = null;
      this.modal.show = true;
    },

    editProducer(item) {
      this.modal.title = this.$t("role.planning.producer.editProducer");
      this.modal.values = item;
      this.modal.editMode = true;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    async removeProducer(id) {
      const response = await apiDelete("role_marketproducer_connections", id, [
        this.$store.state.role.id,
      ]);
      if (response && response.status === 204) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.planning.producer.removedMsg"),
          color: "success",
          autohide: true,
        });
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error removing producer",
          color: "danger",
          autohide: true,
        });
      }
    },

    showDeleteConfirmation(id) {
      this.deleteModal.producerIdToDelete = id;
      this.deleteModal.show = true;
    },

    onModalConfirm() {
      this.deleteModal.show = false;
      this.removeProducer(this.deleteModal.producerIdToDelete);
    },

    onModalClose() {
      this.deleteModal.show = false;
      this.deleteModal.producerIdToDelete = null;
    },

    async fetchData() {
      const response = await apiGet(
        "role_marketproducer_connections",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.producerData = response.data.Items.sort(
          (a, b) => a.producer.id - b.producer.id
        );
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },

    async fetchWh() {
      const response = await apiGet(
        "role_market_planningwh",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.whData = response.data.Items;
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading warehouse data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.fetchWh();
  },
};
</script>
